import axios from 'axios';
import { baseUrl } from '@/config';
import { downloadFile } from '@/utils/file';

export default {
  getDashboard(dashboardId) {
    return axios.get(`${baseUrl}/dashboard/common/get-dashboard.do`, {
      params: {
        dashboardId,
      },
    });
  },
  getDashboardTree(dashboardType) {
    return axios.get(`${baseUrl}/dashboard/common/get-dashboard-tree.do`, {
      params: {
        dashboardType,
      },
    });
  },
  updateDashboardWidget(dashboard) {
    return axios.post(`${baseUrl}/dashboard/common/update-dashboard-widget.do`, dashboard);
  },
  getGroupTreeKey(managegroupId) {
    return axios.get(`${baseUrl}/dashboard/common/get-group-treekey.do`, {
      params: {
        managegroupId,
      },
    });
  },
  updateDashboardTree(gridDashboardTree, coordDashboardTree) {
    return axios.post(`${baseUrl}/dashboard/common/update-dashboard-tree.do`, {
      gridDashboardTree,
      coordDashboardTree,
    });
  },
  getImportDashboardList(type, dashboardType) {
    return axios.get(`${baseUrl}/dashboard/common/get-import-dashboard-list.do`, {
      params: {
        type,
        dashboardType,
      },
    });
  },
  getUploadDashboardInfoOnTree(file) {
    return axios.post(`${baseUrl}/dashboard/common/get-upload-dashboard-info-on-tree.do`, file);
  },
  getImportDashboardInfoOnTree(dashboardId) {
    return axios.get(`${baseUrl}/dashboard/common/get-import-dashboard-info-on-tree.do`, {
      params: {
        dashboardId,
      },
    });
  },
  getTemplateDashboardInfoOnTree(fileName) {
    return axios.get(`${baseUrl}/dashboard/common/get-template-dashboard-info-on-tree.do`, {
      params: {
        fileName,
      },
    });
  },
  downloadDashboardTemplate() {
    const form = document.createElement('form');
    form.action = `${baseUrl}/dashboard/common/download-dashboard-template.do`;
    form.method = 'post';
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    form.appendChild(hiddenField);
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  },
  downloadDashboard(dashboardId) {
    downloadFile(`${baseUrl}/dashboard/common/download-dashboard.do`, { dashboardId }, 'POST');
  },
  updateDashboardCapture(dashboardId, base64) {
    return axios.post(`${baseUrl}/dashboard/common/update-dashboard-capture.do`, {
      dashboardId,
      base64,
    });
  },
  /**
   * 사용자 이미지를 조회한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getCustomimage() {
    return axios.get(`${baseUrl}/dashboard/common/get-customimage.do`);
  },
  /**
   * 이미지 그룹 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @return {[type]} [description]
   */
  getCustomimageTypeList() {
    return axios.get(`${baseUrl}/dashboard/common/get-customimage-type-list.do`);
  },
  /**
   * 그룹별 이미지 리스트를 조회한다.
   * @author KangBonghun(toto1323)
   * @param  {Number} customimagetypeId 이미지그룹 아이디
   * @return {[type]}        [description]
   */
  getCustomimageList(customimagetypeId) {
    return axios.get(`${baseUrl}/dashboard/common/get-imagetype-customimage-list.do`, {
      params: {
        customimagetypeId,
      },
    });
  },
  /**
   * 기존/공유 대시보드 정보 조회
   * @author KangBonghun(toto1323)
   * @param  {[type]} dashboardId [description]
   * @return {[type]}             [description]
   */
  getImportDashboardInfoOnEdit(dashboardId) {
    return axios.get(`${baseUrl}/dashboard/common/get-import-dashboard-info-on-edit.do`, {
      params: {
        dashboardId,
      },
    });
  },
  /**
   * 템플릿 대시보드 정보 조회
   * @author KangBonghun(toto1323)
   * @param  {[type]} fileName [description]
   * @return {[type]}          [description]
   */
  getTemplateDashboardInfoOnEdit(fileName) {
    return axios.get(`${baseUrl}/dashboard/common/get-template-dashboard-info-on-edit.do`, {
      params: {
        fileName,
      },
    });
  },
  /**
   * 템플릿 업로드 대시보드 정보 조회
   * @author KangBonghun(toto1323)
   * @param  {[type]} file [description]
   * @return {[type]}      [description]
   */
  getUploadDashboardInfoOnEdit(file) {
    return axios.post(`${baseUrl}/dashboard/common/get-upload-dashboard-info-on-edit.do`, file);
  },
  /**
   * 대시보드의 슬라이드쇼 목록을 조회한다.
   * @author JungJioon(ryunnnne)
   * @return {[type]} [description]
   */
  getSlideshowList() {
    return axios.get(`${baseUrl}/dashboard/common/get-slideshow-list.do`);
  },
  /**
   * 슬라이드쇼를 추가한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} slideshowName [description]
   * @param  {[type]} slideshowDesc [description]
   */
  addSlideshow(slideshowName, slideshowDesc) {
    return axios.post(`${baseUrl}/dashboard/common/add-slideshow.do`, {
      slideshowName,
      slideshowDesc,
    });
  },
  /**
   * 슬라이드쇼 정보를 수정한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} updateList [description]
   * @return {[type]}            [description]
   */
  updateSlideshow(updateList) {
    return axios.post(`${baseUrl}/dashboard/common/update-slideshow.do`, updateList);
  },
  /**
   * 슬라이드쇼를 삭제한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} slideshowId [description]
   * @return {[type]}             [description]
   */
  deleteSlideshow(slideshowId) {
    return axios.post(`${baseUrl}/dashboard/common/delete-slideshow.do`, {
      slideshowId,
    });
  },
  /**
   * 슬라이드쇼에 설정된 슬라이드 정보를 조회한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} slideshowId [description]
   * @return {[type]}             [description]
   */
  getSlideList(slideshowId) {
    return axios.post(`${baseUrl}/dashboard/common/get-slide-list.do`, {
      slideshowId,
    });
  },
  /**
   * 슬라이드를 추가한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} slideshowId  [description]
   * @param  {[type]} dashboardId  [description]
   * @param  {[type]} delay        [description]
   * @param  {[type]} orderbyIndex [description]
   */
  addSlide(slideshowId, dashboardId, delay, orderbyIndex) {
    return axios.post(`${baseUrl}/dashboard/common/add-slide.do`, {
      slideshowId,
      dashboardId,
      delay,
      orderbyIndex,
    });
  },
  /**
   * 슬라이드 정보를 수정한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} updateList [description]
   * @return {[type]}            [description]
   */
  updateSlide(updateList) {
    return axios.post(`${baseUrl}/dashboard/common/update-slide.do`, updateList);
  },
  /**
   * 슬라이드를 삭제한다.
   * @author JungJioon(ryunnnne)
   * @param  {[type]} slideshowId [description]
   * @param  {[type]} dashboardId [description]
   * @return {[type]}             [description]
   */
  deleteSlide(slideshowId, dashboardId) {
    return axios.post(`${baseUrl}/dashboard/common/delete-slide.do`, {
      slideshowId,
      dashboardId,
    });
  },
  getSqlInfo() {
    return axios.get(`${baseUrl}/dashboard/common/get-sql-info.do`);
  },
  getCoordDashboardEnable() {
    return axios.get(`${baseUrl}/dashboard/common/get-coord-dashboard-enable.do`);
  },
  getCoordDashboardTemplateList() {
    return axios.get(`${baseUrl}/dashboard/common/get-coord-dashboard-template-list.do`);
  },
};



// WEBPACK FOOTER //
// ./src/api/dashboard/common.js